export default __webpack_public_path__ + "static/media/SJA1330.34I-40798_-24115_0.13632937.jpg";